import { LocalityFilter } from 'rentalui-finance';
import { Form } from 'react-bootstrap';
import PriceRangeFilter from './PriceRangeFilter';

// The browse-page filter controls (structured selects + price slider + sort), rendered either as
// an inline bar (desktop) or a stacked column (inside MobileFilterPanel). Shared across verticals.
//
//  browse       the object from useBrowseFilters()
//  filters      [{ key, label, options: [{ value, label }] }]
//  sortOptions  [{ value, label }]
//  priceProps   forwarded to <PriceRangeFilter> (e.g. { ceiling: 50000 } or { ceilingOptions, allowCustomCeiling })
//  stacked      true inside the mobile panel
export default function FilterFields({ browse, filters, sortOptions, priceProps, stacked, localities = [] }) {
  const groupClass = stacked ? 'mb-3' : undefined;
  const w = (px) => (stacked ? undefined : { minWidth: px });

  return (
    <>
      <LocalityFilter value={browse.get('location')} options={localities} onChange={value => browse.setParam('location', value)} />
      {filters.map((f) => (
        <Form.Group key={f.key} className={groupClass} style={w(150)}>
          <Form.Label className="small mb-1 text-muted">{f.label}</Form.Label>
          <Form.Select
            size="sm"
            aria-label={f.label}
            value={browse.get(f.key)}
            onChange={(e) => browse.setParam(f.key, e.target.value)}
          >
            <option value="">Any</option>
            {f.options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
          </Form.Select>
        </Form.Group>
      ))}

      <Form.Group className={groupClass} style={w(230)}>
        <PriceRangeFilter
          value={{ min: browse.minPrice, max: browse.maxPrice }}
          onChange={browse.setPrice}
          {...priceProps}
        />
      </Form.Group>

      <Form.Group className={groupClass} style={w(170)}>
        <Form.Label className="small mb-1 text-muted">Sort</Form.Label>
        <Form.Select
          size="sm"
          aria-label="Sort listings"
          value={browse.sort}
          onChange={(e) => browse.setSort(e.target.value)}
        >
          {sortOptions.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
        </Form.Select>
      </Form.Group>
    </>
  );
}
